import 'core-js/es/map'
import 'core-js/es/set'
import 'core-js/es/array'
import 'raf/polyfill'

import React, { Component } from 'react'
import PDFViewer from './PDFViewer'
import EnhancedEvent from '../helpers/EnhancedEvent'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload, faPrint,faStar, faThumbsUp, faThumbsDown, faMeh, faAngleDoubleDown, faAngleDoubleUp  } from '@fortawesome/free-solid-svg-icons'
library.add(faDownload, faPrint, faStar, faThumbsDown, faThumbsUp, faMeh, faAngleDoubleDown, faAngleDoubleUp);

class Viewer extends Component {
  constructor (props) {
    super(props);
    this.addEnhancedEvent('VIEWER_INIT_START', -1, undefined);
  }

  componentDidMount () {
    this.addEnhancedEvent('VIEWER_MOUNT', -1, undefined);
    this.captureBrowserMetadata();
    this.capturePageMetadata()
  }

  capturePageMetadata () {
    let pageMetadata = {
      referrer: document.referrer || null,
      absoluteUrl: window.location.href,
      resourceUrl: this.props.uri || null,
      url: {
        protocol: window.location.protocol,
        hostname: window.location.hostname,
        host: window.location.host,
        pathname: window.location.pathname,
        query: window.location.search || null,
        hash: window.location.hash || null
      },
      performance: {
        timing: window.performance.timing
      }
    }

    this.addEnhancedEvent('PAGE_METADATA_LOAD', -1, { metadata: pageMetadata });
  }

  captureBrowserMetadata () {
    let browserMetadata = {};

    try {
      browserMetadata = {
        cookieEnabled: window.navigator.cookieEnabled,
        online: window.navigator.onLine,
        timezoneOffset: (new Date()).getTimezoneOffset(),
        window: {
          outerWidth: window.outerWidth,
          innerWidth: window.innerWidth,
          outerHeight: window.outerHeight,
          innerHeight: window.innerHeight
        },
        screen: {
          width: window.screen.width,
          availableWidth: window.screen.availWidth,
          height: window.screen.height,
          availableHeight: window.screen.availHeight
        }
      }
    } catch (e) {}

    try {
      browserMetadata.screen.orientation = { type: window.screen.orientation.type || null }
    } catch (e) {}

    try {
      browserMetadata.userAgent = window.navigator.userAgent || null
    } catch (e) {}

    try {
      browserMetadata.language = window.navigator.systemLanguage || window.navigator.userLanguage || window.navigator.language || null
      browserMetadata.languages = window.navigator.languages || null
    } catch (e) {}

    try {
      const dateTimeFormat = Intl.DateTimeFormat().resolvedOptions()

      browserMetadata.dateTimeFormat = {
        locale: dateTimeFormat.locale || null,
        timezone: dateTimeFormat.timeZone || null
      }

      browserMetadata.numberFormat = { locale: Intl.NumberFormat().resolvedOptions().locale || null }
    } catch (e) {}

    try {
      browserMetadata.connection = {
        downlink: window.navigator.connection.downlink.toString() || null,
        effectiveType: window.navigator.connection.effectiveType || null,
        rtt: window.navigator.connection.rtt || null
      }
    } catch (e) {}

    this.addEnhancedEvent('BROWSER_METADATA_LOAD', -1, { metadata: browserMetadata });
  }

  handleVisibilityChange = (visible, options) => {
    this.addEnhancedEvent(visible ? 'SHOW' : 'HIDE', options.page, undefined);
  }

  handleBlur = (options) => {
    this.addEnhancedEvent('BLUR', options.page, undefined);
  }

  handleFocus = (options) => {
    this.addEnhancedEvent('FOCUS', options.page, undefined);
  }

  handleOffline = (options) => {
    this.addEnhancedEvent('OFFLINE', options.page, undefined);
  }

  handleOnline = (options) => {
    this.addEnhancedEvent('ONLINE', options.page, undefined);
  }

  handleBeforeUnload = (e, options) => {
    this.addEnhancedEvent('CLOSE_BEFORE', options.page, undefined)
  }

  handleUnload = (e, options) => {
    this.addEnhancedEvent('CLOSE', options.page, undefined)
  }

  addEnhancedEvent = (eventType, page, extraParams) => {
    let eventConfig = { type: eventType, page: page };
    if (extraParams) {
      eventConfig = Object.assign(eventConfig, extraParams);
    }

    this.props.enhancedEvents.add(new EnhancedEvent(eventConfig));
  };

  render () {
    return (
      <div className="Viewer">
        <PDFViewer client={this.props.client} title={this.props.title} uri={this.props.uri} viewerPermissions={this.props.viewerPermissions}
                   enhancedEvents={this.props.enhancedEvents} onVisibilityChange={this.handleVisibilityChange}
                   onBeforeUnload={this.handleBeforeUnload} onUnload={this.handleUnload}
                   onBlur={this.handleBlur} onFocus={this.handleFocus} ratingOptions={this.props.ratingOptions}
                   onOffline={this.handleOffline} onOnline={this.handleOnline}
                   onError={this.props.onError} referrer={this.props.referrer} clientActionId={this.props.clientActionId}
                   startTimestamp={this.props.startTimestamp} permsSignature={this.props.permsSignature} />
      </div>
    )
  }
}

export default Viewer
